var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.5C2.65625 0.5 3 0.84375 3 1.25V2.75C3 3.1875 2.65625 3.5 2.25 3.5H0.75C0.3125 3.5 0 3.1875 0 2.75V1.25C0 0.84375 0.3125 0.5 0.75 0.5H2.25ZM14.75 1.25C15.1562 1.25 15.5 1.59375 15.5 2C15.5 2.4375 15.1562 2.75 14.75 2.75H5.25C4.8125 2.75 4.5 2.4375 4.5 2C4.5 1.59375 4.8125 1.25 5.25 1.25H14.75ZM14.75 6.25C15.1562 6.25 15.5 6.59375 15.5 7C15.5 7.4375 15.1562 7.75 14.75 7.75H5.25C4.8125 7.75 4.5 7.4375 4.5 7C4.5 6.59375 4.8125 6.25 5.25 6.25H14.75ZM14.75 11.25C15.1562 11.25 15.5 11.5938 15.5 12C15.5 12.4375 15.1562 12.75 14.75 12.75H5.25C4.8125 12.75 4.5 12.4375 4.5 12C4.5 11.5938 4.8125 11.25 5.25 11.25H14.75ZM0 6.25C0 5.84375 0.3125 5.5 0.75 5.5H2.25C2.65625 5.5 3 5.84375 3 6.25V7.75C3 8.1875 2.65625 8.5 2.25 8.5H0.75C0.3125 8.5 0 8.1875 0 7.75V6.25ZM2.25 10.5C2.65625 10.5 3 10.8438 3 11.25V12.75C3 13.1875 2.65625 13.5 2.25 13.5H0.75C0.3125 13.5 0 13.1875 0 12.75V11.25C0 10.8438 0.3125 10.5 0.75 10.5H2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/iconMenu.225f0b061dfcc4ef8bd10a60067ce8d3.svg";
export { ForwardRef as ReactComponent };